import { Component } from '@angular/core'

@Component({
  templateUrl: './govbar-only-layout.component.html',
})
export class GovbarOnlyLayoutComponent {}
